import { useQuery } from '@tanstack/react-query';
import { listContactTaxonomyHousesHouseIdContactsTaxonomyGetOptions } from '@/client/@tanstack/react-query.gen';

/**
 * The roles this property can file a contact under, grouped as they are drawn.
 *
 * Scoped to the house, unlike the global `/service-categories` it replaces: that one returned every
 * household's custom roles to every other, flat and without the group a picker needs to lay them
 * out. Ordered by the server — groups by `rank`, roles by label — so a reader finds the same role
 * in the same place every time, and callers must not re-sort.
 *
 * Each role carries both names a write needs: `code` for creating a contact, `id` for editing one.
 */
export const useContactTaxonomy = (houseId: number, enabled = true) =>
	useQuery({
		...listContactTaxonomyHousesHouseIdContactsTaxonomyGetOptions({ path: { house_id: houseId } }),
		enabled: !!houseId && enabled,
	});
